import { RowSelectionState, OnChangeFn, PaginationState } from '@tanstack/react-table';
import { useState, useMemo } from 'react';

import { TableExperimentalPaginationState } from '.';

type UseTable = {
  rowSelection: RowSelectionState;
  setRowSelection: OnChangeFn<RowSelectionState>;
  pagination: PaginationState;
  setPagination: React.Dispatch<React.SetStateAction<PaginationState>>;
};

const useTable = (initialPageIndex = 0, initialPageSize = 10): UseTable => {
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});

  const [{ pageIndex, pageSize }, setPagination] = useState<TableExperimentalPaginationState>({
    pageIndex: initialPageIndex,
    pageSize: initialPageSize
  });

  const pagination = useMemo(
    () => ({
      pageIndex,
      pageSize
    }),
    [pageIndex, pageSize]
  );

  return {
    rowSelection,
    setRowSelection,
    pagination,
    setPagination
  };
};

export default useTable;
